<template>
    <div class="charts_el" ref="chartsEl"></div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'GjkcH5StudyDurationLineCharts',

    data() {
        return {

        };
    },

    mounted() {
        // this.initCharts();
    },

    methods: {
        initCharts(dateList,dataList) {
            var chartDom = this.$refs.chartsEl;
            var myChart = echarts.init(chartDom);
            var option;

            option = {
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: dateList
                },
                yAxis: {
                    type: 'value'
                },
                splitLine: {    // 设置网格线
                    lineStyle: {
                        type: 'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                    },
                    show: false //隐藏或显示
                },
                tooltip: {
                    trigger: 'axis',
                    backgroundColor:'#30413D',
                    padding:[5,20,5,20],
                    textStyle:{
                        color:'#fff'
                    }
                },
                // 自定义悬浮提示框内容（数据处理后加单位）
                formatter(params) { // params的个数等于折线的条数（对多条折线数据进行加单位，就需要遍历）
                    var relVal = '学习时长'
                    for (var i = 0, l = params.length; i < l; i++) {
                        relVal += '<br/>' + params[i].value + '分钟'
                    }
                    return relVal
                },
                series: [
                    {
                        data: dataList,
                        type: 'line',
                        lineStyle: {
                            color: 'RGBA(19, 214, 170, 1)'
                        },
                        showSymbol: false,
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: 'RGBA(234, 251, 247, 1)' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#fff' // 100% 处的颜色
                                    }
                                ],
                                global: false // 缺省为 false
                            }
                        },
                        smooth: true,
                        itemStyle:{
                            emphasis:{
                                color:'#fff',
                                borderColor:'RGBA(19, 214, 170, 1)'
                            }
                        }
                    }
                ]
            };

            option && myChart.setOption(option);
        }
    },
};
</script>

<style lang="scss" scoped>
.charts_el {
    width: 100%;
    height: 100%;
}
</style>